export class VoiceMailSearch {
    pbxId: number;
    type = "VOICE_MAIL";

    constructor(pbxId: number) {
        this.pbxId = pbxId;
    }
}
